package game.entity

import com.soywiz.korma.geom.Point
import game.Game
import game.Room

class ImpSpawnPoolBattle : Entity() {
    private var step = 0
    private val impCount = 10
    private var spawnCount = impCount * 4
    private val spawners = listOf(
        Spawner(),
        Spawner(),
        Spawner(),
        Spawner()
    )
    private val spawnerPos = listOf(
        Point(8, 3),
        Point(39, 5),
        Point(13, 16),
        Point(43, 17),
    )
    private val door1 = Door()
    private val door2 = Door()

    override fun onInit(game: Game, room: Room) {

    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                step++
            }
            1 -> {
                if (game.player.row >= 3) {
                    door1.apply {
                        col = 40
                        row = 0
                        room.addEntity(this)
                    }
                    door2.apply {
                        col = 25
                        row = 20
                        room.addEntity(this)
                    }
                    for (i in 0..spawners.lastIndex) {
                        with(spawners[i]) {
                            col = spawnerPos[i].x.toInt()
                            row = spawnerPos[i].y.toInt()
                            params = "imp,${impCount}"
                            onDespawn = {
                                game.message = game.text("Message_SpawnCount", spawnCount)
                                spawnCount--
                            }
                            room.addEntity(this)
                        }
                    }

                    game.playSound("door-close")

                    step++
                }
            }
            2 -> {
                if (spawnCount == 0) {
                    val superImp = Imp(ImpType.RedImp).apply {
                        col = 25
                        row = 12
                        onDeath = {
                            step++
                            game.message = game.text("Message_Victory")
                        }
                    }

                    room.addEntity(superImp)

                    step++
                }
            }
            3 -> {
                // Wait for red-imp to be defeated
            }
            4 -> {
                game.playSound("door-open")
                room.removeEntity(door1)
                room.removeEntity(door2)
                room.removePermanently(game, this)
            }
        }
    }
}